var assignment = {};
export {
  assignment as __exports
};
//# sourceMappingURL=assignment.js.map
